import { useQuery } from "@tanstack/react-query";
import { Alert, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomButton } from "sipli-fleet-core/components";

import fullLogo from "src/assets/full-logo.png";
import { PrivacyPolicyPreview } from "src/container/PrivacyPolicy/PrivacyPolicyForm";
import { getManagedPrivacyPolicy } from "src/services/privacyPolicyService";
import { getDistributorLogo } from "src/util/distributorBranding.service";

interface PrivacyPolicyLocationState {
  returnTo?: string;
}

const PrivacyPolicyPage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const logo = getDistributorLogo(fullLogo);
  const returnTo = (location.state as PrivacyPolicyLocationState | null)?.returnTo || "/";
  const language = i18n.resolvedLanguage || i18n.language;
  const { data: policy, isLoading, isError } = useQuery({
    queryKey: ["PRIVACY_POLICY_LATEST", language],
    queryFn: () => getManagedPrivacyPolicy(language),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return (
    <div className="min-h-screen bg-[#f2f3f7]">
      <header className="flex h-[80px] items-center border-b border-[#d9dce5] bg-white px-6">
        <img src={logo} alt="Logo" className="max-h-12 max-w-37.5" />
      </header>
      <main className="p-6">
        <div className="rounded-2xl bg-white p-6">
          {isLoading ? (
            <div className="flex justify-center py-12">
              <Spin />
            </div>
          ) : isError || !policy?.content ? (
            <Alert type="error" message={t("privacy_policy_load_error")} />
          ) : (
            <PrivacyPolicyPreview markdown={policy.content} showIndex />
          )}

          <div className="mt-8 flex justify-end">
            <CustomButton
              type="primary"
              buttonSize="big"
              label={t("privacy_policy_back")}
              onClick={() => navigate(returnTo, { replace: true })}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicyPage;
